module.exports = {"id":"169416","name":"Carlos Vela","rating":"81","photo":"./data/images/photos/3/169416.png","club":{"name":"Agents libres","logo":"./data/images/clubs/Agentslibres.png"},"positions":["AD","BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CarlosVela0.json
// module id = 729
// module chunks = 0